import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

export default function StatCard({ label, value, icon: Icon, accent = "#2563EB", delay = 0, className, sub }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay, ease: [0.16, 1, 0.3, 1] }}
      className={cn("surface rounded-2xl p-5 flex flex-col gap-3 card-hover", className)}
    >
      <div className="flex items-center justify-between">
        <span className="overline">{label}</span>
        {Icon && (
          <div className="w-8 h-8 rounded-xl flex items-center justify-center"
            style={{ background: `${accent}14` }}>
            <Icon className="h-4 w-4" style={{ color: accent }} />
          </div>
        )}
      </div>
      <div>
        <div className="stat-num" style={{ color: accent }}>{value ?? "—"}</div>
        {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
      </div>
    </motion.div>
  );
}
